// extracted by mini-css-extract-plugin
export var cardTitle = "_jq-1";
export var commentBubble = "_jq-e";
export var commentForm = "_jq-a";
export var commentInput = "_jq-b";
export var commentLabel = "_jq-d";
export var commentPrompt = "_jq-9";
export var csatCard = "_jq-0";
export var feedbackSection = "_jq-7";
export var starDisabled = "_jq-6";
export var starEmpty = "_jq-5";
export var starFilled = "_jq-4";
export var starWrapper = "_jq-3";
export var starsContainer = "_jq-2";
export var submittedComment = "_jq-c";
export var thankYouText = "_jq-8";